export const optionsMapper = options =>
  options?.map(option => ({
    name: option,
    value: option
  }));
